import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-fire-line text-xl text-primary-400"></i>
                </div>
                <span className="font-heading text-lg font-semibold text-background-50">
                  火影同人创作指南
                </span>
              </div>
              <p className="text-background-400 text-sm leading-relaxed">
                最全面的火影忍者同人创作平台，汇聚创作灵感、技巧教程与社区资源，助力每一位同人创作者。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                内容分类
              </h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-background-400 hover:text-primary-400 text-sm transition-colors duration-200"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                快速链接
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/"
                    className="text-background-400 hover:text-primary-400 text-sm transition-colors duration-200"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-background-400 hover:text-primary-400 text-sm transition-colors duration-200"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-background-400 hover:text-primary-400 text-sm transition-colors duration-200"
                  >
                    投稿指南
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-background-400 hover:text-primary-400 text-sm transition-colors duration-200"
                  >
                    版权声明
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                关注我们
              </h4>
              <p className="text-background-400 text-sm mb-4">
                加入火影同人创作社区，与万千同好一起交流创作心得。
              </p>
              <div className="flex gap-3">
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-400 hover:text-background-50 transition-all duration-200"
                  aria-label="微博"
                >
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-400 hover:text-background-50 transition-all duration-200"
                  aria-label="B站"
                >
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-400 hover:text-background-50 transition-all duration-200"
                  aria-label="LOFTER"
                >
                  <i className="ri-quill-pen-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-background-500 text-sm">
              &copy; 2026 火影同人创作指南. 本站为火影忍者同人创作内容平台，所有内容仅供学习交流。
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-background-500 hover:text-background-300 text-sm transition-colors duration-200">
                隐私政策
              </a>
              <a href="#" className="text-background-500 hover:text-background-300 text-sm transition-colors duration-200">
                服务条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}